import * as React from 'react';
import { BaseTabActivator } from './BaseTabActivator';
import { TabsWidget } from './TabsWidget';

/**
 * Automatically activated tabs: tabs are automatically activated and their panel is displayed when they receive focus
 */

export class AutomaticTabActivator extends BaseTabActivator {
  public constructor(tabsWidget: TabsWidget) {
    super(tabsWidget);
  }

  public handleKeyDown(tabIndex: number, keyboardEvent: React.KeyboardEvent<HTMLDivElement>): void {
    const nextActiveTabIndex = this.tabIndexFromKeyDown(tabIndex, keyboardEvent.key);
    if (nextActiveTabIndex !== -1) {
      this.tabsWidget.setActiveIndex(nextActiveTabIndex);
      BaseTabActivator.preventDefaultAndStopPropagation(keyboardEvent);
    }
  }
}
